import { render, staticRenderFns } from "./expandBeAllocated.vue?vue&type=template&id=6b658ef7"
import script from "./expandBeAllocated.vue?vue&type=script&lang=js"
export * from "./expandBeAllocated.vue?vue&type=script&lang=js"
import style0 from "./expandBeAllocated.vue?vue&type=style&index=0&id=6b658ef7&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports